//
//
//
//
//
//
//

import { getSystemInfo } from '@/utils/wx_api'
const { system } = getSystemInfo()
export default {
    props: {
        location: Object,
        is_send: Boolean
    },
    data () {
        return {
            is_ios: system.substring(0, 3).toLowerCase() === 'ios'
        }
    },
    computed: {
        markers () {
            const { name, latitude, longitude } = this.location
            return [{
                id: new Date().getTime(),
                title: name,
                latitude,
                longitude,
                iconPath: 'https://cdn.vip-wifi.com/fangchan/img/chatlist/chat/chat-map-location.png',
                width: 22,
                height: 37
            }]
        }
    },
    methods: {
        openLocation () {
            wx.openLocation({
                ...this.location,
                address: this.location.desc
            })
        }
    }
}
